import "bootstrap/js/dist/modal";
import mixpanel from "common/mixpanel";
import queryString from "query-string";
import YouTubeIframeLoader from "youtube-iframe";
import $ from "jquery";
import placesAutoComplete from "google/places-auto-complete";
import formErrorService from "forms/errors";
import modalQueue from "common/modal-queue";
import pageData from "common/page-data";
import TrackedVideoModal from "common/tracked-video-modal";
import partnerVideoKeys from "common/partner-video-keys";

const params = queryString.parse(window.location.search);
const $mdCouponModal = $("#md-coupon-modal");

mixpanel.track("ABV2.Site.Realtor", pageData.get("mixpanelData"));

if (params.md === "coupon" && $mdCouponModal.length > 0) {
  modalQueue.enqueue($mdCouponModal);
}

// Set up Google autocomplete in the search modals
placesAutoComplete.initializeCityState(
  ".js-realtor-profile-search-form-city-state",
  null,
  pageData.get("currentCountry")
);

$(".js-advertiser-profile-search-form").on("submit", e => {
  const $form = $(e.target);
  const $inputs = $form.find("input[required]");

  for (let i = $inputs.length - 1; i >= 0; i -= 1) {
    const el = $inputs[i];
    if (!$(el).val()) {
      e.preventDefault();
      formErrorService.showErrorInForm(
        "Please enter your name and location in the form below.",
        $form
      );
      break;
    } else {
      formErrorService.hideFormError($form);
    }
  }
});

TrackedVideoModal.load({
  domModalId: "js-realtor-modal",
  domVideoId: "js-realtor-modal__video",
  videoId: pageData.get("videoId") || partnerVideoKeys[pageData.get("partner")],
  showOnload: params.show_video || pageData.get("showVideo"),
  modalQueue
});

YouTubeIframeLoader.load(YT => {
  $("#zipTestimonial").click(() => {
    const zipTestimonialPlayer = new YT.Player("zipTestimonial", {
      videoId: "EFgSVvIQlWM",
      playerVars: { autoplay: "1" }
    });
    $("#zipTestimonialContainer").addClass(
      "embed-responsive embed-responsive-16by9"
    );

    zipTestimonialPlayer.addEventListener("onStateChange", event => {
      if (event.data === YT.PlayerState.ENDED) {
        mixpanel.track("ZipTestimonial.Ended");
      }

      if (event.data === YT.PlayerState.PLAYING) {
        mixpanel.track("ZipTestimonial.Playing");
      }
    });
  });
});

// i18n conditional class
// check for countries we can serve assets for, listed in realtor.scss
const countryIso = `${pageData.get("currentCountry")}`.toLowerCase();
const baseClass = "search-form__callout--";
if (["gb", "ca", "au"].indexOf(countryIso) > -1) {
  $(".search-form__callout").attr("class", baseClass + countryIso);
}
